export const defaultTpSlValue = {
  priceValue: '',
  pnlPercentage: 0,
  deltaPnl: undefined,
  isPnlPercentage: undefined,
  isLong: undefined,
};
